import { Component, EventEmitter, Output, ViewChild, ElementRef, Input, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import { NavTreeSearchBarConfig } from '../../../../interface/nav-panel';
import { DesignElementLocaleHandler } from '../../../../utils/locale';
/**
 * 导航树上方的搜索栏
 * @remarks 可以配置是否显示“全部展开/收起”按钮
 */
@Component({
  selector: 'nav-tree--search-bar',
  templateUrl: './search-bar.html'
})
export class NavTreeSearchBarComponent {

  /** 输入框内容变更 */
  textChange = new Subject();

  /** 搜索栏自定义配置 */
  @Input() config?: NavTreeSearchBarConfig;

  @Output() menuClick = new EventEmitter();

  @ViewChild('toolbar') toolbarEl: ElementRef<any>;
  @ViewChild('searchInput') searchInputEl: ElementRef<any>;

  isExpanded = true;

  localeData = DesignElementLocaleHandler.getValue('codeViewDesigner')
  constructor(private cd: ChangeDetectorRef) { }

  /** 搜索框占位文本 */
  get placeholder(): string {
    return (this.config && this.config.placeholder) || this.localeData.search || "搜索";
  }

  /** 是否显示“全部收起/展开”按钮 */
  get showToggleButton(): boolean {
    if (this.config && this.config.showToggleButton === false) {
      return false;
    }
    return true;
  }

  /** 清空输入框 */
  public clear(): void {
    const inputEl: HTMLInputElement = this.searchInputEl && this.searchInputEl.nativeElement;
    inputEl.value = '';
    this.textChange.next({ event: null, value: '' });
  }

  onTextChange($event: any) {
    const value = $event.target.value;
    this.textChange.next({ event: $event, value });
  }

  clearInput($event: MouseEvent, searchInput: any) {
    $event.stopPropagation();
    searchInput.value = '';
    this.textChange.next({ event: $event, value: '' });
  }

  onMenuItemClick($event: any, key: string) {
    if (key) {
      key = key.toUpperCase();
    }
    this.menuClick.emit({ event: $event, action: { key, value: false }});
  }

  toggleNodes($event: any) {
    this.isExpanded = !this.isExpanded;
    this.onMenuItemClick($event, this.isExpanded ? 'expandall' : 'collapseall');
    this.cd.detectChanges();
  }

  /** 焦点输入框 */
  public focus(): void {
    const inputEl: HTMLInputElement = this.searchInputEl && this.searchInputEl.nativeElement;
    inputEl && inputEl.focus();
  }

}
